import React from 'react'

import { noOp } from '@/utils/helpers'

import type { OnlineUserBase } from '@/components/Worlds/types'

export type GlobalContextType = {
  onlineUsers: OnlineUserBase[]
}

export const GlobalContext = React.createContext<GlobalContextType>({
  onlineUsers: [],
})

export function useGlobalContext(): GlobalContextType {
  return React.useContext(GlobalContext)
}

export type PlatformLayoutContextType = {
  toggleExpandPostId: (postId: number) => void
  expandedPostId: number | null
  toggleShowNotifications: () => void
  showNotifications: boolean
}

export const PlatformLayoutContext = React.createContext<PlatformLayoutContextType>({
  toggleExpandPostId: noOp,
  expandedPostId: null,
  toggleShowNotifications: noOp,
  showNotifications: false,
})

export function usePlatformLayoutContext(): PlatformLayoutContextType {
  return React.useContext(PlatformLayoutContext)
}
